/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * One per-action recommended limit for a given account tier.
 *
 * Purely educational — there is NO usage counting here. ``daily_limit`` is
 * the conservative Unipile-published recommendation for the caller's tier and
 * ``notes`` is the human explanation surfaced in the UI.
 */
export interface LinkedInLimitEntry {
  action: string;
  daily_limit: number;
  notes?: string;
}
